import { Route, Routes } from 'react-router-dom'
import Admin from './pages/Admin/Admin'
import Login from './pages/Login/Login'
import Category from './pages/ManageSyllabus/Category'
import Problems from './pages/ManageSyllabus/Problems'
import SubCategory from './pages/ManageSyllabus/SubCategory'
import AddSession from './pages/ManageSessions/AddSession'
import AddNotification from './pages/ManageNotifications/AddNotification'
import NotFound from './pages/NotFound/NotFound'
import EditorialContent from './pages/SyllabusContent/Editorials/EditorialContent'
import Editorials from './pages/SyllabusContent/Editorials/Editorials'
import ProblemSetter from './pages/SyllabusContent/ProblemSetter/ProblemSetter'
import VideoContent from './pages/SyllabusContent/VideoContent'
import ProblemSetterForm from './pages/SyllabusContent/ProblemSetter/ProblemSetterForm'
import AddUser from './pages/AddUser/AddUser'
import ProblemSetterPreview from './pages/SyllabusContent/ProblemSetter/ProblemSetterPreview'
import CreateEditor from './pages/CreateEditor/CreateEditor'
import ProtectedRoute from './utils/ProtectedRoute'
import EditorialContentPreview from './pages/SyllabusContent/Editorials/EditorialContentPreview'
import { useDispatch } from 'react-redux';
import { useEffect } from 'react'
import { getAllCategories, getAllDeletedProblems, getAllProblems, getAllSubCategories } from './services/operations/syllabus'
import Plans from './pages/ManagePremium/Plans'
import CouponCode from './pages/ManagePremium/CouponCode'
import DeletedProb from './pages/ManageSyllabus/DeletedProb'
import UploadTextFile from './pages/UploadTextFile/UploadTextFile'
import UploadImage from './pages/UploadImage/UploadImage'
import Affiliates from './pages/ManagePremium/Affiliates'
import CreateImageSlider from './pages/CreateImageSlider/CreateImageSlider'
import GrantAccess from './pages/ManagePremium/GrantAccess'
// import SalesTabsRender from './pages/ManagePremium/SalesTracker/SalesTabs'
import AddConfig from './pages/ManagePremium/Configs'
// import DoubtCostInfo from './pages/ManagePremium/comments'
import TabsRender from './pages/ManageBugReports/BugsTab'
import DislikedProblems from './pages/ManageSyllabus/DislikedProblems'
// import JudgeStats from './pages/ManagePremium/JudgeStats'
import ErrorDashboard from './pages/Errors/Errors'
import PlusUpdates from './pages/PlusUpdates/PlusUpdates'
import StatsPage from './pages/StatsPage'
import Whitelist from './pages/ManagePremium/Whitelist.jsx'
import { getAllAptitudeProblems, getAllCategories_v2, getAllDSAProblems, getAllQuizProblems, getAllSubCategories_v2, getAllTheoryProblems, getAllTopics } from './services/operations/new-syllabus'
import TheoryContent from './pages/ManageContent/TheoryContent';
import QuizContent from './pages/ManageContent/QuizContent';
import DSAContent from './pages/ManageContent/DSAContent';
import DSAContentEdit from './pages/ManageContent/DSAContent/Edit';
import EditorialPreview from './pages/ManageContent/DSAContent/EditorialPreview';
import TheoryContentEdit from './pages/ManageContent/TheoryContent/Edit';
import QuizContentEdit from './pages/ManageContent/QuizContent/Edit';
import AllSubject from './pages/AllSubjects/AllSubject';
import AllCategory from './pages/AllCategory/AllCategory';
import AllSubCategory from './pages/AllSubCategory/AllSubCategory';
import SyllabusOrder from './pages/SyllabusOrder/SyllabusOrder';
import StoriesTabs from './pages/ManagePremium/Stories/StoriesTab';
import TheoryPreview from './pages/ManageContent/TheoryContent/TheoryPreview'
import UploadImageCore from './pages/UploadImage/UploadImageCore'
import MyCourses from './pages/ManageCourses/MyCourses'
import { getMyCourses, getPartnersCourses } from './services/operations/courses'
import PartherCourses from './pages/ManageCourses/PartherCourses'
import NewEditorialPreview from './pages/ManageContent/DSAContent/NewEditorialPreview'
import V2GrantPremiumAccess from './pages/V2GrantPremiumAccess/V2GrantPremiumAccess'
import SalesTabs from './pages/ManageSales/SaleTabs'
import SalesUserStats from './pages/ManageSales/SalesUserStats'
import SalesFeedback from './pages/ManageSales/SalesFeedback'
import AptitudeContent from './pages/ManageContent/AptituteContent/AptitudeContent.jsx'
import AptitudeEdit from './pages/ManageContent/AptituteContent/AptitudeEdit.jsx'
import AllInterviewExperiences from './pages/ManageInterviewExperiences/AllInterviewExperiences.jsx'
import { getAllInterviewExperiences } from './services/operations/interviewExperiences.js'
import InterviewExperience from './pages/ManageInterviewExperiences/InterviewExperience.jsx'
import InterviewExperienceEditDraft from './pages/ManageInterviewExperiences/InterviewExperienceEditDraft.jsx'
import AllCompanies from './pages/ManageCompanies/Companies.jsx'
import { getAllCompanies } from './services/operations/companies.js'
import ManageAds from './pages/ManagePremium/ManageAds.jsx'
import ManagePosts from './pages/ManagePremium/ManagePosts.jsx'
import ManageEmiOption from './pages/ManagePremium/ManageEmiOption.jsx'

const App = () => {

    const dispatch = useDispatch()

    useEffect(() => {
      dispatch(getAllCategories());
      dispatch(getAllProblems());
      dispatch(getAllDeletedProblems());
      dispatch(getAllSubCategories());
      dispatch(getAllDSAProblems());
      dispatch(getAllTheoryProblems());
      dispatch(getAllQuizProblems());
      dispatch(getAllCategories_v2());
      dispatch(getAllSubCategories_v2());
      dispatch(getAllTopics());
      dispatch(getMyCourses());
      dispatch(getPartnersCourses());
      dispatch(getAllAptitudeProblems());
      dispatch(getAllInterviewExperiences())
      dispatch(getAllCompanies())
  }, [dispatch]); 

    return (
      <div>
        <Routes>
          <Route path='/' element={<Login />} />
          
          <Route element={<ProtectedRoute />}>
            <Route path='/admin' element={<Admin />} />

            <Route path='/create-editor' element={<CreateEditor />} />

            <Route path='/manage-syllabus/category' element={<Category />} />
            <Route path='/manage-syllabus/sub-category' element={<SubCategory />} />
            <Route path='/manage-syllabus/problems' element={<Problems />} />
            <Route path='/manage-syllabus/deletedProblems' element={<DeletedProb />} />
            <Route path='/manage-syllabus/dislikedproblems' element={<DislikedProblems />} />

            <Route path='/syllabus-content/video' element={<VideoContent />} />
            <Route path='/syllabus-content/editorials' element={<Editorials />} />
            <Route path='/syllabus-content/editorials/:id' element={<EditorialContent />} />
            <Route
              path='/syllabus-content/editorials/:id/preview'
              element={<EditorialContentPreview />}
            />
            <Route path='/syllabus-content/problem-setter' element={<ProblemSetter />} />
            <Route path='/syllabus-content/problem-setter/:id' element={<ProblemSetterForm />} />
            <Route
              path='/syllabus-content/problem-setter/:id/preview'
              element={<ProblemSetterPreview />}
            />


            <Route path='/manage-content/all-dsa-problem' element={<DSAContent/>} />
            <Route path='/manage-content/all-aptitude-problem' element={<AptitudeContent/>} />
            <Route
                path='/manage-content/all-dsa-problem/:slug'
                element={<DSAContentEdit />}
            />
            <Route path='/manage-content/problem/preview' element={<EditorialPreview />} />
            <Route path='/manage-content/problem/new-preview' element={<NewEditorialPreview />} />

            <Route path='/manage-content/all-theory-problem' element={<TheoryContent />} />
            <Route path='/manage-content/theory/preview' element={<TheoryPreview />} />

            <Route
                path='/manage-content/all-theory-problem/:slug'
                element={<TheoryContentEdit />}
            />

            <Route
                path='/manage-content/all-aptitude-problem/:slug'
                element={<AptitudeEdit />}
            />

            <Route path='/manage-content/all-quiz-problem' element={<QuizContent />} />
            <Route
                path='/manage-content/all-quiz-problem/:slug'
                element={<QuizContentEdit />}
            />

            <Route path='/manage-courses/my-courses' element={<MyCourses/>} />
            <Route path='/manage-courses/parther-courses' element={<PartherCourses/>} />
            
            <Route path='topics/all-subjects' element={<AllSubject />} />

            <Route path='topics/all-categories' element={<AllCategory />} />
            <Route path='topics/all-sub-categories' element={<AllSubCategory />} />

            <Route path='/syllabus/:subject' element={<SyllabusOrder />} />

            <Route path='/manage-sessions' element={<AddSession />} />
            <Route path='/manage-notifications' element={<AddNotification />} />
            <Route path='/manage-plus-updates' element={<PlusUpdates />} />

            <Route path='/interview/all-interview-experiences' element={<AllInterviewExperiences />} />
            <Route path='/interview/all-interview-experiences/:id' element={<InterviewExperience />} />
            <Route path='/interview/companies' element={<AllCompanies />} />
            <Route path='/interview/all-interview-experiences/draft/:id' element={<InterviewExperienceEditDraft />} />

            <Route path='/add-user' element={<AddUser />} />

            <Route path='/manage-premium/add-config' element={<AddConfig />} />
            <Route path='/manage-premium/plans' element={<Plans />} />
            <Route path='/manage-premium/coupons' element={<CouponCode />} />
            <Route path='/manage-premium/affiliates' element={<Affiliates />} />
            <Route path='/manage-premium/privileged-users' element={<GrantAccess />} />

            <Route path='/reported-bugs' element={<TabsRender />} />
            {/* <Route
                        path='/manage-premium/total-sales'
                        element={
                            <SalesTabsRender />
                        }
                    /> */}
            {/* <Route path='/manage-premium/doubt-costs' element={<DoubtCostInfo />} />
            <Route path='/manage-premium/judge-stats' element={<JudgeStats />} /> */}
            <Route path='/manage-premium/stories' element={<StoriesTabs />} />
            <Route path='/manage-premium/userStats' element={ < StatsPage /> } />
            <Route path='/manage-premium/whitelist' element={ < Whitelist /> } />
            <Route path='/manage-premium/ads' element={<ManageAds />} />
            <Route path="/manage-premium/landing-page-posts" element={<ManagePosts />} />
            <Route path="/manage-premium/emi-option" element={<ManageEmiOption />} />

            <Route path='/upload-text-file' element={<UploadTextFile />} />

            <Route path='/upload-image' element={<UploadImage />} />
            <Route path='/upload-image-core' element={<UploadImageCore />} />
            <Route path='/create-image-slider' element={<CreateImageSlider />} />

            <Route path='/errors' element={ < ErrorDashboard /> } />
            <Route path='/premium/grant-premium-access' element={ <V2GrantPremiumAccess /> } />

            <Route path='/manage-sales/failed' element={ < SalesTabs userType='failed' /> } />
            <Route path='/manage-sales/dropped' element={ < SalesTabs userType='dropped' /> } />
            <Route path='/manage-sales/whatsapp' element={ < SalesTabs userType='whatsapp' /> } />
            <Route path='/manage-sales/sales-user-stats' element={ < SalesUserStats /> } />
            <Route path='/manage-sales/feedback' element={ < SalesFeedback /> } />
          </Route>
          <Route path='*' element={<NotFound />} />
        </Routes>
      </div>
    );
}

export default App